module.exports = __webpack_public_path__ + "842712df1b9137c424563120d984c1fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Contest/images/background.jpg
// module id = 404
// module chunks = 0